import React from 'react'
import sopPDF from '../../../assests/ambassador-sop.pdf'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'

function ViewSop() {
    return (
        <>
            <Breadcrumb data="Standard Operating Procedure" />
            <div className='content-body'>
                <div className='table-data'>
                    <div className='mb-5 border-1 rounded-3'>
                        <embed src={sopPDF} width="100%" height="600px" />
                    </div>
                    <iframe className='border-1 rounded-3' width="100%" height="600px" src="https://www.youtube.com/embed/gfCwLgllZzo" title="Ambassador Video of FTL Directorate of Ambassador DEMO" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>

        </>
    )
}

export default ViewSop
